import { Boundaries } from "@planzone/core";
import { Group, Identifiable } from "@planzone/dto";

function handleRemoveResourceFromResourceGroupRequest(
  group: Identifiable<Group>,
  req: Boundaries["removeResourceFromResourceGroup"]["request"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? {
        ...group,
        resources: group.resources.filter((resource) =>
          group.resourceType === "project"
            ? resource.resource.uuid !== req.resource.uuid
            : resource.uuid !== req.resource.uuid,
        ),
      }
    : group;
}

function handleRemoveResourceFromResourceGroupSuccess(
  group: Identifiable<Group>,
  req: Boundaries["removeResourceFromResourceGroup"]["success"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? {
        ...group,
        resources: group.resources.filter((resource) =>
          group.resourceType === "project"
            ? resource.resource.uuid !== req.resource.uuid
            : resource.uuid !== req.resource.uuid,
        ),
      }
    : group;
}

function handleRemoveResourceFromResourceGroupFailure(
  group: Identifiable<Group>,
  req: Boundaries["removeResourceFromResourceGroup"]["failure"],
): Identifiable<Group> {
  return group.uuid === req.group.uuid
    ? {
        ...group,
        resources: [...group.resources, req.resource],
      }
    : group;
}

export {
  handleRemoveResourceFromResourceGroupRequest,
  handleRemoveResourceFromResourceGroupSuccess,
  handleRemoveResourceFromResourceGroupFailure,
};
